export enum JournalStatus{
  Open = "Open",
  Closed = 'Closed'
}


